import { useTranslation } from 'hooks/useTranslation'
import { BlobTitle } from '../BlobTitle'
import { TextBlock } from '../TextBlock'
import { FoodForWeightLossRoot } from './FoodForWeightLoss.styles'
import { TextWrapper } from '../TextBlock/TextBlock.styles'

export const FoodForWeightLoss = () => {
  const { t } = useTranslation()

  return (
    <FoodForWeightLossRoot id="raw-benefits-5">
      <BlobTitle
        title={t('raw-benefits:food-for-weight-loss.title')}
        subtitle={t('raw-benefits:food-for-weight-loss.subtitle')}
        icon="weight"
        blob="/assets/raw-benefits/food-for-weight-loss-blob.svg"
        variant="foodForWeightLoss"
      />
      <TextWrapper order='low'>
        <TextBlock i18nKey="raw-benefits:food-for-weight-loss.body" />
      </TextWrapper>
    </FoodForWeightLossRoot>
  )
}
